import api from '../../services/api'
import {
  ORGANIZATION_SUCCESS,
  ORGANIZATION_IS_FETCHING,
  ORGANIZATION_LIST
} from '../types'

function getOrganizationByName (organizationName) {
  return (dispatch) => {
    dispatch(isFetching(ORGANIZATION_IS_FETCHING, true))

    return api.organization.getOrganizationByName(organizationName).then(response => {
      if (response.data.error === null) {
        dispatch({
          type: ORGANIZATION_SUCCESS,
          payload: response.data.result
        })
      } else {
        return response
      }
      return response
    }).then((response) => {
      dispatch(isFetching(ORGANIZATION_IS_FETCHING, false))
      return response
    }).catch(() => {
      dispatch(isFetching(ORGANIZATION_IS_FETCHING, false))
    })
  }
}

function getOrganizations () {
  return (dispatch) => {
    dispatch({
      type: ORGANIZATION_IS_FETCHING,
      payload: true
    })

    return api.organization.getOrganizations()
      .then((response) => {
        if (response && !response.data.error) {
          dispatch({
            type: ORGANIZATION_LIST,
            payload: response.data.result
          })
        }

        dispatch({
          type: ORGANIZATION_IS_FETCHING,
          payload: false
        })
      })
  }
}

function isFetching (type, payload) {
  return {
    type,
    payload
  }
}

export {
  getOrganizationByName,
  getOrganizations
}



// WEBPACK FOOTER //
// ./src/store/actions/organization.js